module.exports = __webpack_public_path__ + "static/media/1001195.a447f1c7.png";